import { render, staticRenderFns } from "./OrgHomeInventoryRetainedVsSettled.vue?vue&type=template&id=ffdfa178&scoped=true&"
import script from "./OrgHomeInventoryRetainedVsSettled.vue?vue&type=script&lang=js&"
export * from "./OrgHomeInventoryRetainedVsSettled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdfa178",
  null
  
)

export default component.exports